import React from 'react';

// Demo Environment Detection
export const isDemoEnvironment = () => {
  return (
    window.location.hostname === 'demo.sheltercareconnect.com' ||
    window.location.hostname.includes('demo') ||
    process.env.REACT_APP_DEMO_MODE === 'true'
  );
};

// Demo Banner Component
export const DemoBanner = () => {
  if (!isDemoEnvironment()) return null;
  
  return (
    <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-4 py-2 text-center font-semibold text-sm shadow-lg relative z-50">
      <div className="flex items-center justify-center space-x-2">
        <span className="animate-pulse">🎮</span>
        <span>DEMO ENVIRONMENT - SAMPLE DATA ONLY</span>
        <span className="animate-pulse">🎮</span>
      </div>
      <div className="text-xs opacity-90 mt-1">
        All resident and staff information is fictional • Safe to explore • Not connected to real shelter operations
      </div>
    </div>
  );
};

// Demo Data Watermark
export const DemoWatermark = ({ children, className = "" }) => {
  if (!isDemoEnvironment()) return children;
  
  return (
    <div className={`relative ${className}`}>
      {children}
      <div className="absolute top-2 right-2 bg-orange-100 border-2 border-orange-400 text-orange-700 px-2 py-1 rounded-lg text-xs font-semibold opacity-75 pointer-events-none">
        DEMO DATA
      </div>
    </div>
  );
};

// Demo Alert for Sensitive Areas
export const DemoAlert = ({ title, children }) => {
  if (!isDemoEnvironment()) return children;
  
  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <span className="text-2xl">ℹ️</span>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">
              {title || "Demo Environment"}
            </h3>
            <div className="mt-2 text-sm text-blue-700">
              <p>
                You're viewing sample data in a demonstration environment. 
                All information shown is fictional and created for software demonstration purposes only.
              </p>
            </div>
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

// Demo Footer
export const DemoFooter = () => {
  if (!isDemoEnvironment()) return null;
  
  return (
    <div className="bg-gray-800 text-white py-4 px-4 mt-8">
      <div className="max-w-7xl mx-auto text-center">
        <div className="flex items-center justify-center space-x-2 mb-2">
          <span className="text-orange-400 text-xl">⚠️</span>
          <span className="font-semibold">DEMONSTRATION ENVIRONMENT</span>
          <span className="text-orange-400 text-xl">⚠️</span>
        </div>
        <p className="text-sm text-gray-300">
          This is a demo version of Shelter Care Connect with fictional data only.
        </p>
        <div className="mt-3 space-x-4">
          <a 
            href="/" 
            className="text-blue-400 hover:text-blue-300 text-sm underline"
          >
            Visit Production Site
          </a>
          <a 
            href="/beta" 
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm inline-block"
          >
            Apply for Beta Testing
          </a>
        </div>
      </div>
    </div>
  );
};

// Demo User Warning
export const DemoUserInfo = () => {
  if (!isDemoEnvironment()) return null;
  
  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
      <div className="flex items-center">
        <span className="text-yellow-600 mr-2">👤</span>
        <div className="text-sm">
          <strong>Demo User:</strong> You're logged in as a demonstration user. 
          All actions are safe and use sample data only.
        </div>
      </div>
    </div>
  );
};

export default {
  isDemoEnvironment,
  DemoBanner,
  DemoWatermark,
  DemoAlert,
  DemoFooter,
  DemoUserInfo
};